import ApplicationAdapter from './application';

export default class MlpAdapter extends ApplicationAdapter {
  // Defaults
  coalesceFindRequests = false;
}
